const angular = require('angular');

const AnnouncerServiceDefinition = require('./announcer.service');

angular.module('oly.common')
    .service('AnnouncerService', AnnouncerServiceDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/accessibility/index.js